import {createAction} from '@reduxjs/toolkit'
import {
  BI_ORIGINS,
  EventsDates,
  PAST_EVENT_STATUSES,
  UPCOMING_EVENT_STATUSES,
  getEventId,
} from '@wix/wix-events-commons-statics'
import {setActiveElement} from '../../../../commons/actions/focus-handler'
import {EventsList, Tabs} from '../../../../commons/enums'
import {getLocale} from '../../../../commons/selectors/environment'
import {getEventUrl} from '../../../../commons/selectors/event'
import {openModal} from '../../../../commons/services/modal'
import {isTicketedWithNoOrder} from '../selectors/event'
import {getMemberId, isOwnProfile} from '../selectors/user'
import {createAsyncAction} from '../services/redux-toolkit'
import {DetailedEvent} from '../types/state'
import {getMyTickets} from './tickets'

interface GetEventsResponse {
  events: wix.events.Event[]
  orders: wix.events.ticketing.Order[]
  rsvps: wix.events.rsvp.Rsvp[]
  total: number
  dates: {events: EventsDates}
}

export const getEvents = createAsyncAction<GetEventsResponse, {tab: Tabs}>(
  'GET_EVENTS',
  async ({tab}, {getState, extra: {serverApi}}) => {
    const state = getState()
    const isUpcoming = tab === Tabs.UPCOMING
    const statuses = isUpcoming ? UPCOMING_EVENT_STATUSES : PAST_EVENT_STATUSES
    const offset = state.events[isUpcoming ? EventsList.UPCOMING : EventsList.PAST].length
    const memberId = getMemberId(state)
    const locale = getLocale(state)

    return serverApi.getEvents({
      memberId,
      statuses,
      extended: isOwnProfile(state),
      offset,
      locale,
    })
  },
)

export const toggleEventDetails = createAsyncAction<string, {event: DetailedEvent}>(
  'TOGGLE_EVENT_DETAILS',
  async ({event}, {getState, dispatch}) => {
    const eventId = getEventId(event.event)
    const state = getState()

    if (state.user.currentUserId === state.user.viewedSiteMemberId && isTicketedWithNoOrder(event)) {
      dispatch(getMyTickets({eventId}))
    }

    return eventId
  },
)

export const closeAllEvents = createAction('CLOSE_ALL_EVENTS')

export const setTab = createAction<Tabs>('SET_TAB')

interface ShareEventArgs {
  event: DetailedEvent
  returnFocusElement?: string
}

export const shareEvent = createAsyncAction<void, ShareEventArgs>(
  'SHARE_EVENT',
  async ({event: {event}, returnFocusElement}, {getState, dispatch, extra: {pageUrl}}) => {
    const eventId = getEventId(event)
    const eventUrl = getEventUrl(pageUrl, event, getState().multilingual)

    dispatch(shareEventClicked())
    await dispatch(
      openModal({
        type: 'share-event',
        params: {eventUrl, eventId, origin: BI_ORIGINS.MEMBERS_AREA},
      }),
    )
    dispatch(setActiveElement(returnFocusElement))
  },
)

export const seeOtherEvents = createAction('SEE_OTHER_EVENTS')

export const shareEventClicked = createAction('SHARE_EVENT_CLICKED')
